import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAllowedApproval } from "amnPos/ticket/Ticket";
import { RootState } from "app/store";

export interface IApprovalsState {
  externalOperationsApprovals: IAllowedApproval[];
  clientApprovals: IAllowedApproval[];
  ticketsApprovals: IAllowedApproval[];
  standAloneTicketsApprovals: IAllowedApproval[];
}

var initialState: IApprovalsState = {
  externalOperationsApprovals: [],
  clientApprovals: [],
  ticketsApprovals: [],
  standAloneTicketsApprovals: [],
};

export const approvalsSlice = createSlice({
  name: "approvalsSlice",
  initialState,
  reducers: {
    resetApprovalsSlice: () => initialState,
    addTicketApprovals: (state, action: PayloadAction<IAllowedApproval[]>) => {
      state.ticketsApprovals?.push(...action.payload);
      return state;
    },
    resetTicketApprovals: (state) => {
      state.ticketsApprovals = [];
      return state;
    },
    addExternalOperationsApprovals: (
      state,
      action: PayloadAction<IAllowedApproval[]>,
    ) => {
      state.externalOperationsApprovals?.push(...action.payload);
      return state;
    },
    resetExternalOperationsApprovals: (state) => {
      state.externalOperationsApprovals = [];
      return state;
    },
    addClientsApprovals: (state, action: PayloadAction<IAllowedApproval[]>) => {
      state.clientApprovals?.push(...action.payload);
      return state;
    },
    resetClientsApprovals: (state) => {
      state.clientApprovals = [];
      return state;
    },
    addStandAloneTicketsApprovals: (
      state,
      action: PayloadAction<IAllowedApproval[]>,
    ) => {
      state.standAloneTicketsApprovals?.push(...action.payload);
      return state;
    },
    resetStandAloneTicketsApprovals: (state) => {
      state.standAloneTicketsApprovals = [];
      return state;
    },
  },
});

export const {
  resetApprovalsSlice,
  addTicketApprovals,
  addExternalOperationsApprovals,
  addClientsApprovals,
  addStandAloneTicketsApprovals,
  resetTicketApprovals,
  resetExternalOperationsApprovals,
  resetClientsApprovals,
  resetStandAloneTicketsApprovals,
} = approvalsSlice.actions;

export const localRouter = (state: RootState) => state.localRouter;

export default approvalsSlice.reducer;
